export default __webpack_public_path__ + "static/media/referAFriend.0b89b50d.png";